import cookie from 'react-cookies';

const PERMISSIONS_KEY = 'rbac_permissions';
const IS_ADMIN_KEY = 'rbac_is_admin';
const ROLES_KEY = 'rbac_roles';
const CAN_MANAGE_RBAC_KEY = 'can_manage_rbac';
const WAREHOUSE_UID_KEY = 'warehouse_uid';
const WAREHOUSE_NAME_KEY = 'warehouse_name';

export function getRbacIsAdmin() {
  const value = cookie.load(IS_ADMIN_KEY);
  return value === true || value === 'true';
}

export function getCanManageRbac() {
  const value = cookie.load(CAN_MANAGE_RBAC_KEY);
  return value === true || value === 'true' || getRbacIsAdmin();
}

export function getRbacPermissions() {
  const value = cookie.load(PERMISSIONS_KEY);
  return Array.isArray(value) ? value : [];
}

export function getRbacRoles() {
  const value = cookie.load(ROLES_KEY);
  return Array.isArray(value) ? value : [];
}

export function getUserWarehouse() {
  const uid = cookie.load(WAREHOUSE_UID_KEY);
  if (!uid) return null;

  return {
    uid,
    name: cookie.load(WAREHOUSE_NAME_KEY) || uid
  };
}

export function saveUserWarehouseCookies({ warehouse_uid, warehouse_name } = {}) {
  if (warehouse_uid !== undefined && warehouse_uid !== null && warehouse_uid !== '') {
    cookie.save(WAREHOUSE_UID_KEY, warehouse_uid, { path: '/' });
  } else if (warehouse_uid !== undefined) {
    cookie.remove(WAREHOUSE_UID_KEY, { path: '/' });
  }

  if (warehouse_name !== undefined && warehouse_name !== null && warehouse_name !== '') {
    cookie.save(WAREHOUSE_NAME_KEY, warehouse_name, { path: '/' });
  } else if (warehouse_name !== undefined) {
    cookie.remove(WAREHOUSE_NAME_KEY, { path: '/' });
  }
}

export function clearUserWarehouseCookies() {
  cookie.remove(WAREHOUSE_UID_KEY, { path: '/' });
  cookie.remove(WAREHOUSE_NAME_KEY, { path: '/' });
}

export function saveRbacCookies({
  rbac_permissions,
  rbac_roles,
  rbac_is_admin,
  can_manage_rbac,
  warehouse_uid,
  warehouse_name
}) {
  if (rbac_is_admin !== undefined) {
    cookie.save(IS_ADMIN_KEY, !!rbac_is_admin, { path: '/' });
  }
  if (rbac_permissions !== undefined) {
    cookie.save(PERMISSIONS_KEY, rbac_permissions, { path: '/' });
  }
  if (rbac_roles !== undefined) {
    cookie.save(ROLES_KEY, rbac_roles, { path: '/' });
  }
  if (can_manage_rbac !== undefined || rbac_is_admin !== undefined) {
    const manage =
      can_manage_rbac !== undefined ? !!can_manage_rbac : !!rbac_is_admin;
    cookie.save(CAN_MANAGE_RBAC_KEY, manage, { path: '/' });
  }
  if (warehouse_uid !== undefined || warehouse_name !== undefined) {
    saveUserWarehouseCookies({ warehouse_uid, warehouse_name });
  }
}

export function clearRbacCookies() {
  cookie.remove(PERMISSIONS_KEY, { path: '/' });
  cookie.remove(IS_ADMIN_KEY, { path: '/' });
  cookie.remove(ROLES_KEY, { path: '/' });
  cookie.remove(CAN_MANAGE_RBAC_KEY, { path: '/' });
  cookie.remove('rbac_grantable_sensitive_families', { path: '/' });
  clearUserWarehouseCookies();
}

export async function refreshRbacFromCurrentUser(fetchCurrentUser) {
  const data = await fetchCurrentUser();
  saveRbacCookies({
    rbac_permissions: data.rbac_permissions || [],
    rbac_roles: data.rbac_roles || [],
    rbac_is_admin: !!data.rbac_is_admin,
    can_manage_rbac: !!data.can_manage_rbac || !!data.rbac_is_admin,
    warehouse_uid: data.warehouse_uid,
    warehouse_name: data.warehouse_name,
  });
  return data;
}
